import { Component } from '@angular/core';
import { TableViewFiltersAbstractComponent } from '../../ui/filterable-table/tableViewFiltersAbstractComponent';
import { SearchFilters } from '../../../models/search/searchFilters';
import {
  SearchField,
  SearchFieldType,
} from '../../../models/search/searchField';
import { SearchService } from '../../../models/search/searchService';

@Component({
  selector: 'app-global-search-filters',
  templateUrl: './global-search-filters.component.html',
  standalone: false,
})
export class GlobalSearchFiltersComponent extends TableViewFiltersAbstractComponent {
  textFieldType: SearchFieldType = SearchFieldType.TextBox;
  ddlFieldType: SearchFieldType = SearchFieldType.DropDownList;

  searchFields: SearchField[] = [];
  filters: SearchFilters;

  constructor(search: SearchService) {
    super();

    this.searchFields = search.getSearchFields('');

    this.filters = new SearchFilters({});
  }

  public getFilters(): any {
    this.filters.filters = [];

    for (var i = 0; i < this.searchFields.length; i++) {
      if (
        this.searchFields[i].filterValue &&
        this.searchFields[i].filterValue?.trim() != ''
      ) {
        this.filters.filters.push(this.searchFields[i]);
      }
    }

    return this.filters;
  }
}
